import { ISelectableOption, useTheme, TooltipHost, DirectionalHint, Text, IRenderFunction } from '@fluentui/react';
import { ColumnDto } from '../../../../../api/generated/data-contracts';
import { DESELECT_KEY } from '../../../../../constants/queryKeys';

export const ComboBoxTooltip = (props: ISelectableOption<ColumnDto> & { children: React.ReactNode }) => {
    const theme = useTheme();

    return (
        <TooltipHost
            calloutProps={{
                styles: { beak: { backgroundColor: theme.semanticColors.bodyBackground }, root: { backgroundColor: theme.semanticColors.bodyBackground } },
            }}
            content={
                <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 10, backgroundColor: theme.semanticColors.bodyBackground }}>
                    <Text>
                        <strong>Display name</strong>
                    </Text>
                    <Text>{`${props.data?.displayName}`}</Text>
                    <Text>
                        <strong>Logical name</strong>
                    </Text>
                    <Text>{`${props.data?.logicalName}`}</Text>
                </div>
            }
            directionalHint={DirectionalHint.topLeftEdge}
        >
            {props.children}
        </TooltipHost>
    );
};

export const onRenderOption: IRenderFunction<ISelectableOption<ColumnDto>> = (props, defaultRender) => {
    if (props && defaultRender) {
        const { key, text } = props;
        if (key === DESELECT_KEY) {
            return <strong>{text}</strong>;
        }
        return <ComboBoxTooltip {...props}>{defaultRender(props)}</ComboBoxTooltip>;
    }
    return null;
};
